export enum CheckboxStatus {
  nochecked = 'nochecked',
  checked = 'checked',
  indeterminate = 'indeterminate',
  disabled = 'disabled',
}
